import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import $ from "jquery";

import {Link} from "react-router-dom";
import ViewComplaint from "../ViewComplaint/ViewComplaint";
import ShowMoreText from "react-show-more-text";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import newIcon from "../../../../assets/img/icons8-new-48.png";
import canvasDown from "../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../assets/img/canvasup.png";

class ComplaintRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lastRepliedBy: '',
            lastReplyStatus: ''
        };

        // this.getLastRepliedUser = this.getLastRepliedUser.bind(this);
        // this.getLastReplyStatus = this.getLastReplyStatus.bind(this);
    }

    /* getLastRepliedUser = () => {
         axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiry.id + '/reply/last')
             .then((res) => {
                 this.setState({
                     lastRepliedBy: res.data
                 });
                 // console.log(res.data);
             })
             .catch((err) => {
                 console.log("[API] ERROR: ", err);
             });
     };*/

    /* getLastReplyStatus = () => {
         axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiry.id + '/reply/last/status')
             .then((res) => {
                 this.setState({
                     lastReplyStatus: res.data
                 });
                 // console.log(res.data);
             })
             .catch((err) => {
                 console.log("[API] ERROR: ", err);
             });
     };*/

    componentDidMount() {
        // this.getLastRepliedUser();
        // this.getLastReplyStatus();
        var collapsed = true;
        setTimeout(() => {

            $('.btnCollapse').children('.minus').hide()

            $(".btnCollapse").click(function () {
                collapsed = !collapsed;
                if (collapsed) {
                    $(this).children('.minus').hide()
                    $(this).children('.plus').show()
                    $(this).parent().parent().children('.collapseContent').slideUp('slow');
                } else {

                    $(this).children('.plus').hide()
                    $(this).children('.minus').show()
                    $(this).parent().parent().children('.collapseContent').slideDown('slow');
                }
            });
        }, 10)
    }

    render() {

        let repliesLength = this.props.inquiry.complaintReplies.length;
        let lastReply = this.props.inquiry.complaintReplies[repliesLength - 1];

        return (
            <div>
                <div className="container-fluid responsive-userAddress-table">
                    <div className="row">
                        <div className="col-md-1 no-padding">
                            {this.props.index}
                        </div>
                        <div className="col-md-2 no-padding">
                            <div className="custom-col-6">{this.props.inquiry.createdDate.substring(0, 4)}年 {this.props.inquiry.createdDate.substring(5, 7)}月&nbsp;
                                {this.props.inquiry.createdDate.substring(8, 10)}日&nbsp;</div>
                            <div className="custom-col-6"> {this.props.inquiry.createdDate.substring(11, 16)}</div>

                        </div>
                        <div className="col-md-3 ">
                        <span>
                            {/*{this.props.inquiry.subject}*/}
                            <FormattedMessage id="app.complaint-subject-manufacture"
                                              defaultMessage="製造上の問題"
                                              description=""/>

                        </span>
                        </div>
                        <div className="col-md-4 no-padding">
                            <div>
                                {this.props.inquiry.complaintReplies.length === 0 ? <text>-</text> :
                                    <text>
                                        <ShowMoreText
                                            lines={3}
                                            more='...詳細'
                                            less='...閉じる'
                                            anchorClass=''
                                        >
                                            {lastReply.replyMessage}
                                        </ShowMoreText>
                                    </text>
                                }
                            </div>
                        </div>
                        <div className="col-md-2">
                            <ViewComplaint inquiryData={this.props.inquiry} lastReplyStatus={this.state.lastReplyStatus}
                                           getUserComplaints={this.props.getUserComplaints}
                                           activePage={this.props.activePage}/>
                            &nbsp;
                            {/*{this.props.inquiry.inquiryReplies.length !== 0 &&*/}
                            {/*{console.log("asdfgtrewq ", this.props.inquiry)}*/}
                            {this.props.inquiry.hasNewRepliesToUser === true &&
                            <p className="new-text-resp-complaint">NEW</p>
                            }
                            {/*<button className="btn btn-xs btn-danger" onClick={this.deleteItemClicked} >
                            <FormattedMessage id="app.inquiry-row.delete"
                                              defaultMessage="Delete"
                                              description=""/>
                        </button>*/}
                            {/*<Link to={"reply/" + this.props.inquiry.id} className="link">*/}
                            {/*<FormattedMessage id="app.admin-inquiry-row.reply"*/}
                            {/*defaultMessage="Reply"*/}
                            {/*description=""/>*/}
                            {/*</Link>*/}
                        </div>
                    </div>
                    <div className="row">
                        <hr/>
                    </div>
                </div>
                {/*///////////////////////////////////////////////////////////////////////////*/}
                <div className="responsive-userAddress-table-mobile">
                    <div className="">

                        <div className="title-background2-responsive">
                            <div className="custom-col-2">
                                {this.props.inquiry.hasNewRepliesToUser === true &&
                                <span className="new-text-resp-complaint-resp">NEW</span>
                                }
                            </div>
                            <div className="custom-col-8 text-center-responsive">
                                # {this.props.index}
                            </div>
                            <div className="custom-col-1 float-right-plus btnCollapse">
                                <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                            </div>
                            <div className="custom-col-1"></div>
                        </div>

                        <div className="collapseContent complaint-mobile-content">
                            <hr/>
                            <div className="no-padding collapse-light-gray">
                                <label>
                                    <FormattedMessage id="app.complaint-header.date"
                                                      defaultMessage="Date"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="">
                                {this.props.inquiry.createdDate.substring(0, 4)}年 {this.props.inquiry.createdDate.substring(5, 7)}月&nbsp;
                                {this.props.inquiry.createdDate.substring(8, 10)}日&nbsp;{this.props.inquiry.createdDate.substring(11, 16)}
                            </div>


                            <div className="collapse-light-gray">
                                <label>
                                    <FormattedMessage id="app.complaint-header.subject"
                                                      defaultMessage="Subject"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="">
                        <span>
                            <FormattedMessage id="app.complaint-subject-manufacture"
                                              defaultMessage="製造上の問題"
                                              description=""/>
                        </span>
                            </div>


                            <div className="collapse-light-gray">
                                <label>
                                    <FormattedMessage id="app.complaint-row.reply"
                                                      defaultMessage="Last Reply"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="">
                                <div>
                                    {this.props.inquiry.complaintReplies.length === 0 ? <text>-</text> :
                                        <text>
                                            <ShowMoreText
                                                lines={3}
                                                more='...詳細'
                                                less='...閉じる'
                                                anchorClass=''
                                            >
                                                {lastReply.replyMessage}
                                            </ShowMoreText>
                                        </text>
                                    }
                                </div>
                            </div>


                            <div className="collapse-light-gray">
                                <label>
                                    <FormattedMessage id="app.complaint-header.actions"
                                                      defaultMessage="Actions"
                                                      description=""/>
                                </label>
                            </div>
                            <div className="" id="mobile-complaint-resp-view">
                                <br/> <ViewComplaint inquiryData={this.props.inquiry}
                                               lastReplyStatus={this.state.lastReplyStatus}
                                               getUserComplaints={this.props.getUserComplaints}
                                               activePage={this.props.activePage}/>

                            </div>
                        </div>
                    </div>


                    <div className="">
                        <hr/>
                    </div>
                </div>
                {/*///////////////////////////////////////////////////////////////////////////*/}
            </div>

        )


    }
}

export default ComplaintRow;



// WEBPACK FOOTER //
// ./src/components/Site/QualityComplaintNew/ComplaintRow/ComplaintRow.js